import React from 'react';
import { CalendarDaysIcon, CarFrontIcon, HotelIcon, MapPinnedIcon } from 'lucide-react';
const GUIDE_POINTS = [{
  icon: HotelIcon,
  title: 'Stay close to your care',
  body: 'Your four hotel nights are arranged within minutes of the Dadeland clinic, so recovery never feels far from support.'
}, {
  icon: CarFrontIcon,
  title: 'Local transport is handled',
  body: 'Round trip Uber from MIA or FLL and clinic transportation are included. Airfare to Miami is not included.'
}, {
  icon: MapPinnedIcon,
  title: 'A calm five days in Miami',
  body: 'Between checkups, you can rest, enjoy the hotel, and experience the city at your own pace before flying home.'
}, {
  icon: CalendarDaysIcon,
  title: 'A Miami plan at your pace',
  body: 'Ask the team for current exhibits, a relaxed waterfront walk, or a quiet nearby dinner that fits your recovery schedule.'
}];
export function MiamiGuide() {
  return <section className="w-full bg-[var(--white)] py-20 lg:py-28" aria-labelledby="miami-guide-title" data-id="element-131" data-mp="2ykqy1jmoku4o">
      <div className="mx-auto max-w-6xl px-6" data-id="element-132" data-mp="12p3z8rdlh4z3">
        <div className="relative overflow-hidden rounded-[2rem] bg-[#111314] shadow-soft" data-id="element-133" data-mp="17hx7hp89uvfx">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/1f55416d-b21d-411d-b38b-26d5537f6c71.jpg" alt="Miami skyline and Biscayne Bay at sunset" className="absolute inset-0 h-full w-full object-cover" loading="lazy" data-id="element-134" data-mp="tr1rzu39pg3d" />
          <div className="absolute inset-0 bg-[#111314]/35" aria-hidden="true" data-id="element-135" data-mp="1qh17k8hu5evg" />
          <div className="relative grid min-h-[620px] grid-cols-1 items-end lg:min-h-[500px] lg:grid-cols-[1.05fr_0.95fr]" data-id="element-136" data-mp="1ch0a730s4pkq">
            <div className="m-5 rounded-3xl bg-[#111314]/95 p-7 text-[#FAFAFC] sm:m-8 sm:p-9 lg:m-10" data-id="element-137" data-mp="1hf1shlqdskv5">
              <p className="text-sm font-bold uppercase tracking-[0.14em] text-[#F4EEE3]" data-id="element-138" data-mp="10jpovadbir0">Your Miami, made easy</p>
              <h2 id="miami-guide-title" className="mt-4 text-3xl font-bold leading-tight sm:text-4xl" data-id="element-139" data-mp="61ha7eiuoovo">
                Your treatment trip can still feel like Miami.
              </h2>
              <p className="mt-4 max-w-xl text-lg leading-relaxed text-[#FAFAFC]/80" data-id="element-140" data-mp="3e3f6qfnzr9o5">
                You are coming for a clinical result, not a complicated itinerary. The Dadeland clinical team plans the essential local details so you can focus on your recovery and the smile you are taking home.
              </p>
              <p className="mt-4 border-l-2 border-[#F4EEE3] pl-4 text-xs leading-relaxed text-[#FAFAFC]/70" data-id="element-141" data-mp="2zf15282b9r96">
                Your care is based at 8950 SW 74th Ct, Unit 1506, Dadeland, Miami, FL 33156.
              </p>
              <div className="mt-8 space-y-5" data-id="element-142" data-mp="2qevxnxx4asv0">
                {GUIDE_POINTS.map(point => {
                const Icon = point.icon;
                return <div key={point.title} className="flex gap-4" data-id="element-143" data-mp="ok3pr4er32dw">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#F4EEE3] text-[#111314]" data-id="element-144" data-mp="jlsfiskjmpv5">
                        <Icon size={20} aria-hidden="true" data-id="element-145" data-mp="r51oikp50mjo" />
                      </span>
                      <div data-id="element-146" data-mp="w3w6jkfa672q">
                        <h3 className="font-bold text-[#FAFAFC]" data-id="element-147" data-mp="w3395a27otx9">{point.title}</h3>
                        <p className="mt-1 text-sm leading-relaxed text-[#FAFAFC]/75" data-id="element-148" data-mp="10w633jawi5dz">{point.body}</p>
                      </div>
                    </div>;
              })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}